import React, { useEffect, useState } from "react";
import DashboardLayout from "../components/DashboardLayout";
import api from "../lib/api";
import { Link } from "react-router-dom";
import { StatusBadge } from "./Dashboard";
import { Package, ExternalLink } from "lucide-react";

export default function Shipments() {
  const [items, setItems] = useState([]);
  const [filter, setFilter] = useState("ALL");
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    (async () => {
      const { data } = await api.get("/shipments");
      setItems(data);
      setLoading(false);
    })();
  }, []);

  const filtered = filter === "ALL" ? items : items.filter((s) => s.status === filter);

  return (
    <DashboardLayout>
      <div className="flex items-center justify-between mb-8">
        <div>
          <div className="text-xs uppercase tracking-[0.2em] text-zinc-500">Shipments</div>
          <h1 className="font-display text-3xl font-black tracking-tighter">All shipments</h1>
        </div>
        <Link to="/dashboard/shipments/new" data-testid="shipments-new-btn" className="brand-bg text-white px-5 py-2 rounded-sm hover:opacity-90 text-sm font-medium">
          + New shipment
        </Link>
      </div>

      <div className="flex flex-wrap gap-2 mb-4">
        {["ALL", "BOOKED", "IN_TRANSIT", "OUT_FOR_DELIVERY", "DELIVERED", "VOIDED"].map((f) => (
          <button
            key={f}
            data-testid={`filter-${f}`}
            onClick={() => setFilter(f)}
            className={`px-3 py-1 rounded-sm text-[10px] sm:text-xs uppercase tracking-wider whitespace-nowrap ${
              filter === f ? "brand-bg text-white" : "border border-zinc-300 text-zinc-700 hover:bg-zinc-50"
            }`}
          >
            {f.replace(/_/g, " ")}
          </button>
        ))}
      </div>

      <div className="bg-white border border-zinc-200 rounded-sm overflow-hidden">
        {loading ? (
          <div className="p-12 text-center text-zinc-500 font-mono-plex text-sm">Loading_</div>
        ) : filtered.length === 0 ? (
          <div className="p-16 text-center">
            <Package size={36} className="mx-auto text-zinc-300" />
            <div className="mt-3 text-zinc-500 text-sm">No shipments here.</div>
          </div>
        ) : (
          <div className="overflow-x-auto">
          <table className="w-full text-sm min-w-[780px]">
            <thead>
              <tr className="text-xs uppercase tracking-wider text-zinc-500 border-b border-zinc-200">
                <th className="text-left py-3 px-4">Book #</th>
                <th className="text-left">Tracking</th>
                <th className="text-left">Carrier</th>
                <th className="text-left">From → To</th>
                <th className="text-left">Status</th>
                <th className="text-right">Total</th>
                <th className="text-right px-4">Actions</th>
              </tr>
            </thead>
            <tbody>
              {filtered.map((s) => (
                <tr key={s.book_number} className="border-b border-zinc-100 hover:bg-zinc-50" data-testid={`shipment-row-${s.book_number}`}>
                  <td className="py-3 px-4 font-mono-plex">{s.book_number}</td>
                  <td className="font-mono-plex text-xs">{s.tracking_number}</td>
                  <td>{s.carrier_name}<div className="text-xs text-zinc-500">{s.service_name}</div></td>
                  <td className="text-xs">
                    <div>{s.sender.city}, {s.sender.state}</div>
                    <div className="text-zinc-500">→ {s.receiver.city}, {s.receiver.state}</div>
                  </td>
                  <td><StatusBadge status={s.status} /></td>
                  <td className="text-right font-mono-plex">${s.total.toFixed(2)}</td>
                  <td className="text-right px-4">
                    <Link to={`/dashboard/track/${s.book_number}`} className="brand-text text-xs flex items-center gap-1 justify-end">
                      Track <ExternalLink size={12} />
                    </Link>
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
          </div>
        )}
      </div>
    </DashboardLayout>
  );
}
